/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ZipNotifyCompleteRequest } from '../models/ZipNotifyCompleteRequest';
import type { ZipNotifyCompleteResponseApiRespoonse } from '../models/ZipNotifyCompleteResponseApiRespoonse';
import type { ZipNotifyRegenerateZipfileRequest } from '../models/ZipNotifyRegenerateZipfileRequest';
import type { ZipNotifyRegenerateZipfileResponseApiRespoonse } from '../models/ZipNotifyRegenerateZipfileResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ZipManagementNotifyService {

    /**
     * complete
     * @param requestBody
     * @returns ZipNotifyCompleteResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static zipNotifyComplete(
        requestBody: ZipNotifyCompleteRequest,
    ): CancelablePromise<ZipNotifyCompleteResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/zip-notify/complete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Regenerate
     * @param requestBody
     * @returns ZipNotifyRegenerateZipfileResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static zipNotifyReGenerate(
        requestBody: ZipNotifyRegenerateZipfileRequest,
    ): CancelablePromise<ZipNotifyRegenerateZipfileResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/zip-notify/re-generate',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
